const initialState = {
  lobbies: [],
  chatMessages: [],
  /* The room put this account out (the host removed it, or another tab gave the seat up) and
     nothing else is navigating: the lobby route takes the player home and clears this. */
  sentHome: false,
}

export default initialState
